import { RoutersType } from "../type/routes";
import SCRR010001 from "../pages/SCRR010001";
import SCRR411102 from "../pages/SCRR411102";
import SCRR410030 from "../pages/SCRR410030";
import SCRR410003 from "../pages/SCRR410003";
import SCRR410001 from "../pages/SCRR410001";
import SCRR411105 from "../pages/SCRR411105";
import SCRR411106 from "../pages/SCRR411106";
import SCRR410028 from "../pages/SCRR410028";
import SCRR411107 from "../pages/SCRR411107";
import SCRR411108 from "../pages/SCRR411108";
import SCRR411109 from "../pages/SCRR411109";
import SCRR411110 from "../pages/SCRR411110";
import SCRR411111 from "../pages/SCRR411111";
import SCRR411112 from "../pages/SCRR411112";
import SCRR411113 from "../pages/SCRR411113";
import SCRR411115 from "../pages/SCRR411115";
import SCRR411123 from "../pages/SCRR411123";
import SCRR411124 from "../pages/SCRR411124";
import SCRR410017 from "../pages/SCRR410017";
import SCRR411114 from "../pages/SCRR411114";
import SCRR411118 from "../pages/SCRR411118";
import SCRR411119 from "../pages/SCRR411119";
import SCRR411120 from "../pages/SCRR411120";
import SCRR411121 from "../pages/SCRR411121";
import SCRR410022 from "../pages/SCRR410022";
import SCRW070008 from "../pages/SCRW070008";
import SCRC050127 from "../pages/SCRC050127";
import SCRC050028 from "../pages/SCRC050028";
import SCRR411125 from "../pages/SCRR411125";
import SCRR411126 from "../pages/SCRR411126";
import SCRR410027 from "../pages/SCRR410027";
import SCRR410016 from "../pages/SCRR410016";
import SCRR410004 from "../pages/SCRR410004";
import SCRC060028 from "../pages/SCRC060028";
import SCRC060026 from "../pages/SCRC060026";
import SCRC060125 from "../pages/SCRC060125";
import SCRC060031 from "../pages/SCRC060031";
import SCRR010002 from "../pages/SCRR010002";
/**
 * アプリケーションのルートオブジェクトの配列です。
 * @typedef {Object} RoutersType
 * @property {string} name - ルートの名前。
 * @property {string} path - ルートのパス。
 * @property {React.ComponentType} component - ルートにレンダリングするコンポーネント。
 */
const routes: RoutersType[] = [
  /**
   * 退職者認証のルート情報
   */
  {
    name: "退職者認証",
    path: "/SCRR010001",
    component: SCRR010001,
    meta: {
      title: "退職者認証",
    },
  },
  {
    name: "請求者入力",
    path: "/SCRR010002",
    component: SCRR010002,
    meta: {
      title: "請求者入力",
    },
  },
  {
    name: "退職手当金の請求手続き又は合算制度利用手続き",
    path: "/SCRR411102",
    component: SCRR411102,
    meta: {
      title: "退職手当金の請求手続き又は合算制度利用手続き",
      contextName: "job_32,job_35,job_36,job_37,job_38",
    },
  },
  {
    name: "退職手当金の請求手続き（振込状況の確認）",
    path: "/SCRR410030",
    component: SCRR410030,
    meta: {
      title: "退職手当金の請求手続き（振込状況の確認）",
      contextName: "job_37",
    },
  },
  {
    name: "退職手当金の請求手続き前の書類の準備",
    path: "/SCRR410003",
    component: SCRR410003,
    meta: {
      title: "退職手当金の請求手続き前の書類の準備",
      contextName: "job_35,job_41",
    },
  },
  {
    name: "退職手当金請求者の情報入力",
    path: "/SCRR410001",
    component: SCRR410001,
    meta: {
      title: "退職手当金請求者の情報入力",
    },
  },
  {
    name: "退職手当金の請求手続き（退職者確認）",
    path: "/SCRR410004",
    component: SCRR410004,
    meta: {
      title: "退職手当金の請求手続き（退職者確認）",
      contextName: "job_35,job_36",
    },
  },
  {
    name: "退職手当金の請求手続き（請求者の確認）",
    path: "/SCRR411105",
    component: SCRR411105,
    meta: {
      title: "退職手当金の請求手続き（請求者の確認）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（請求者情報の登録）",
    path: "/SCRR411106",
    component: SCRR411106,
    meta: {
      title: "退職手当金の請求手続き（請求者情報の登録）",
    },
  },
  {
    name: "退職手当金の請求手続き（請求者情報の登録）",
    path: "/SCRR410028",
    component: SCRR410028,
    meta: {
      title: "退職手当金の請求手続き（請求者情報の登録）",
      contextName: "",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（機構へ連絡）",
    path: "/SCRR410022",
    component: SCRR410022,
    meta: {
      title: "退職手当金受領者の変更手続き（機構へ連絡）",
      contextName: "job_39,job_40",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（連絡先の登録）",
    path: "/SCRR411119",
    component: SCRR411119,
    meta: {
      title: "退職手当金受領者の変更手続き（連絡先の登録）",
      contextName: "job_39,job_40",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（退職者との続柄の確認）",
    path: "/SCRR411120",
    component: SCRR411120,
    meta: {
      title: "退職手当金受領者の変更手続き（退職者との続柄の確認）",
      contextName: "job_39,job_40",
    },
  },

  {
    name: "退職手当金受領者の変更手続き（請求権者の証明書類の添付）",
    path: "/SCRR411121",
    component: SCRR411121,
    meta: {
      title: "退職手当金受領者の変更手続き（請求権者の証明書類の添付）",
      contextName: "job_39,job_40",
    },
  },
  {
    name: "退職手当金の請求手続き（振込先金融機関の登録）",
    path: "/SCRR411107",
    component: SCRR411107,
    meta: {
      title: "退職手当金の請求手続き（振込先金融機関の登録）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（受給権者確認添付書類）",
    path: "/SCRR411108",
    component: SCRR411108,
    meta: {
      title: "退職手当金の請求手続き（受給権者確認添付書類）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（本人確認書類の登録）",
    path: "/SCRR411109",
    component: SCRR411109,
    meta: {
      title: "退職手当金の請求手続き（本人確認書類の登録）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（退職所得の申告書の登録）",
    path: "/SCRR411110",
    component: SCRR411110,
    meta: {
      title: "退職手当金の請求手続き（退職所得の申告書の登録）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（源泉徴収票の確認）",
    path: "/SCRR411111",
    component: SCRR411111,
    meta: {
      title: "退職手当金の請求手続き（源泉徴収票の確認）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（退職所得の源泉徴収票登録））",
    path: "/SCRR411112",
    component: SCRR411112,
    meta: {
      title: "退職手当金の請求手続き（退職所得の源泉徴収票登録）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（退職所得の申告書の作成１）",
    path: "/SCRR411113",
    component: SCRR411113,
    meta: {
      title: "退職手当金の請求手続き（退職所得の申告書の作成１）",
      contextName: "job_35",
    },
  },
  {
    name: "退職手当金の請求手続き（退職所得の申告書の作成２）",
    path: "/SCRR411115",
    component: SCRR411115,
    meta: {
      title: "退職手当金の請求手続き（退職所得の申告書の作成２）",
      contextName: "job_35",
    },
  },

  {
    name: "退職手当金受領者の変更手続き（請求者の登録）",
    path: "/SCRR411123",
    component: SCRR411123,
    meta: {
      title: "退職手当金受領者の変更手続き（請求者の登録）",
      contextName: "job_41",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（振込先金融機関の登録）",
    path: "/SCRR411124",
    component: SCRR411124,
    meta: {
      title: "退職手当金受領者の変更手続き（振込先金融機関の登録）",
      contextName: "job_41",
    },
  },
  {
    name: "部分解除　内容入力",
    path: "/SCRC050127",
    component: SCRC050127,
    meta: {
      title: "部分解除　内容入力",
      contextName: "job_16",
    },
  },
  {
    name: "部分解除　入力内容確認",
    path: "/SCRC050028",
    component: SCRC050028,
    meta: {
      title: "部分解除　入力内容確認",
      contextName: "job_16,searchForHistory",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（添付書類の登録）",
    path: "/SCRR411125",
    component: SCRR411125,
    meta: {
      title: "退職手当金受領者の変更手続き（添付書類の登録）",
      contextName: "job_41",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（本人確認の書類の添付）",
    path: "/SCRR411126",
    component: SCRR411126,
    meta: {
      title: "退職手当金受領者の変更手続き（本人確認の書類の添付）",
      contextName: "job_41",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（登録内容の確認）",
    path: "/SCRR410027",
    component: SCRR410027,
    meta: {
      title: "退職手当金受領者の変更手続き（登録内容の確認）",
      contextName: "job_41",
    },
  },
  {
    name: "退職手当金の請求手続き（登録内容の確認）",
    path: "/SCRR410016",
    component: SCRR410016,
    meta: {
      title: "退職手当金の請求手続き（登録内容の確認）",
      contextName: "job_35,searchForHistory",
    },
  },
  {
    name: "合算制度利用申出の手続き（機構への提出確認）",
    path: "/SCRR410017",
    component: SCRR410017,
    meta: {
      title: "合算制度利用申出の手続き（機構への提出確認）",
      contextName: "job_36,searchForHistory",
    },
  },
  {
    name: "合算制度利用申出の手続き（機構への提出確認）",
    path: "/SCRR411114",
    component: SCRR411114,
    meta: {
      title: "合算制度利用申出の手続き（機構への提出確認）",
      contextName: "job_36",
    },
  },
  {
    name: "合算制度利用申出の手続き",
    path: "/SCRR411118",
    component: SCRR411118,
    meta: {
      title: "合算制度利用申出の手続き",
      contextName: "job_36",
    },
  },
  {
    name: "退職者状況一覧",
    path: "/SCRW070008",
    component: SCRW070008,
    meta: {
      title: "退職者状況一覧",
      contextName: "job_01",
    },
  },
  {
    name: "退職情報　登録（登録内容の確認）",
    path: "/SCRC060028",
    component: SCRC060028,
    meta: {
      title: "退職情報　登録（登録内容の確認）",
      contextName: "job_32,agentRequest,searchForHistory",
    },
  },
  {
    name: "退職情報　登録（登録内容の確認）",
    path: "/SCRC060026",
    component: SCRC060026,
    meta: {
      title: "退職情報　登録（登録内容の確認）",
      contextName: "job_32,retirement,agentRequest,searchForHistory",
    },
  },
  {
    name: "退職情報　登録（添付書類の確認）",
    path: "/SCRC060125",
    component: SCRC060125,
    meta: {
      title: "退職情報　登録（添付書類の確認）",
      contextName: "job_32,retirement,agentRequest",
    },
  },
  {
    name: "退職者状況　管理",
    path: "/SCRC060031",
    component: SCRC060031,
    meta: {
      title: "退職者状況　管理",
      contextName: "retirement",
    },
  },
];

export { routes };
